import { queryClient } from 'Context/QueryClientContext';
import { useMutation } from '@tanstack/react-query';
import { ActivitiesApi } from 'Data/ActivitiesApi';
import { QUERY_KEY_ACTIVITIES_FOLLOWERS } from 'Data/keys/QueryKeys';
import { IFollowersAddRequest } from 'Data/interfaces/Activities/IFollowers';
import { IUserData } from 'Data/interfaces/User/IUserData';

export const useQueryAddFollowers = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IFollowersAddRequest) => {
      return ActivitiesApi.addFollowers(variables);
    },
    onMutate: async (variables) => {
      const previousFollowers = queryClient.getQueryData<IUserData[]>(
        [QUERY_KEY_ACTIVITIES_FOLLOWERS, variables.topicId],
      );

      queryClient.setQueryData<IUserData[]>(
        [QUERY_KEY_ACTIVITIES_FOLLOWERS, variables.topicId],
        (oldData) => {
          if (oldData) {
            return [...oldData, ...variables.followers];
          }
          return variables.followers;
        },
      );

      return { previousFollowers };
    },
    onError: async (_error, variables, context) => {
      await queryClient.cancelQueries({
        queryKey: [QUERY_KEY_ACTIVITIES_FOLLOWERS, variables.topicId],
        exact: true,
      });

      if (context?.previousFollowers !== undefined) {
        queryClient.setQueryData<IUserData[]>(
          [QUERY_KEY_ACTIVITIES_FOLLOWERS, variables.topicId],
          context?.previousFollowers,
        );
      }
    },
  });

  return {
    addFollowers: mutate,
    isLoading: isPending,
  };
};
